import { type ReactNode } from 'react';

interface SectionHeadingProps {
  icon: ReactNode;
  children: ReactNode;
  count?: number;
}

/**
 * Heading for the side-by-side Makes / Comments columns. Shared so the two
 * can't drift apart on icon, weight, or count styling.
 */
export default function SectionHeading({
  icon,
  children,
  count,
}: SectionHeadingProps) {
  return (
    <h2 className="font-primary font-bold text-2xl min-h-10 flex items-center gap-2.5">
      {icon}
      {children}
      {/* Explicit undefined check — a genuine 0 should still render. */}
      {count !== undefined && (
        <span className="text-muted-foreground">{count}</span>
      )}
    </h2>
  );
}
